// extracted by mini-css-extract-plugin
module.exports = {"pageContainer":"page_pageContainer__KCxQH"};